import { apiGet, apiPost, apiPatch, apiDelete } from "./client";
import type { SearchNote } from "@career-ops-amplify/shared";

export type { SearchNote };

export async function listNotes(): Promise<{ notes: SearchNote[] }> {
  return apiGet("/api/notes");
}

export async function createNote(
  content: string,
): Promise<{ note: SearchNote }> {
  return apiPost("/api/notes", { content });
}

export async function updateNote(
  id: string,
  content: string,
): Promise<{ note: SearchNote }> {
  return apiPatch(`/api/notes/${id}`, { content });
}

export async function deleteNote(id: string): Promise<{ ok: boolean }> {
  return apiDelete(`/api/notes/${id}`);
}
